class fn_core {
   rowsh(e, x, y) {
      engine.shown.process(e.currentTarget.getAttribute('data-id'));
   }
   reqin(e) {
      $(e.currentTarget).hideError();
   }
//selectnek külön van
   reqout(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var d = engine.row[row.data('id')];
      row.removeClass('v').addClass('v');
      console.log('reqout', row);
      if (va == null) {
         row.trigger('rowError', 'req');
         return;
      }
      if (typeof va != 'object') {
         if (!va.length) {
            row.trigger('rowError', 'req');
            return;
         }
      } else {
         var r = 0;
         if (d.type == 'date') {
            switch (d.show) {
               case 111:
                  if (va['y'] && va['m'] && va['d']) r = 1;
               case 112:
                  if (va['y'] && va['m']) r = 1;
               case 100:
                  if (va['y']) r = 1;
            }

         } else {
            $.each(va, function (k, v) {
               if (v != null && v.length) {
                  r = 1;
                  return false;
               }
            });
         }
         if (!r) $(e.currentTarget).trigger('rowError', 'req');
      }
   }
   selfChkRet(row, d) {
      if (typeof d == 'undefined') return;
      if (d.replace != null) row.rVal(d.replace);
      if (d.valid) {
         row.hideError();
         return;
      }
      row.trigger('rowError', 'inv');
   }
   autologin_check() {
      $(engine.settings.form.id).on('click','.next', function (e, c) {
         console.log('autologin_check confirmed', c);
         if (c == 'confirmed') return;
//         if (!$(e.originalEvent.currentTarget).hasClass('next')) {
//             alert('got it!');
//             return;
//         }
         var va = {};
         $('.row.alc:visible').each(function () {
            var row = $(this);
            va[row.attr('id')] = row.rVal();
         });
         var r = engine.ajaxFunc('autologin_check', va);
         if (typeof r == 'undefined' || !r.stop) return;
         e.preventDefault();
         engine.popMsg(r.msg);
      });
      $('#pop_msg').on('click', '.ui-btn', function (e) {
         if ($(e.currentTarget).hasClass('ell')) engine.popMsg('');
         else $(engine.settings.form.id).trigger('submit', 'confirmed')
      });
   }
   gTracker() {
      (function (i, s, o, g, r, a, m) {
         i['GoogleAnalyticsObject'] = r;
         i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
         }, i[r].l = 1 * new Date();
         a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
         a.async = 1;
         a.src =
            g;
         m.parentNode.insertBefore(a, m)
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
      ga('create', engine.settings.goog.c, 'auto');
   }
   gCoversation(l) {
      window.google_trackConversion({
         google_conversion_id: 1065961914,
         google_conversion_language: 'hu',
         google_conversion_format: 2,
         google_conversion_color: 'ffffff',
         google_conversion_label: l,
         google_remarketing_only: false,
      });
   }
   getPart(g, success) {
      if (typeof success != 'function') success = function (s, st, xhr) {};
      $.ajax({
         url: engine.settings.engineUrl + engine.settings.engine + '/index.php',
         data: {g: g},
         dataType: 'script',
         type: 'GET',
         cache: true,
         timeout: 3000,
         async: false,
         success: success
      });
   }
   mincmp(e) {
      var row = $(e.currentTarget);
      var d = engine.row[row.data('id')];
      var r = engine.rowmap[d.dp.min_cmp.f];
      if (typeof r == 'undefined') return;
      var t = $('#table_engine #tb_' + r);
      var va = row.rVal();
      console.log('mincmp');
      console.log(va);
      //var date = new Date(va.y, va.m - 1, va.d, 0, 0, 0, 0);
      var date = new Date(d.dp.min_cmp.y, d.dp.min_cmp.m - 1, d.dp.min_cmp.d, 0, 0, 0, 0);
      console.log('1', date);
      date = engine.fn.formatYMD(date);
      console.log('2', date);
      var ti = t.find('input');
      ti.attr('min', date.replace(/\//g, '-'));
      if (ti.hasClass('hasDatepicker')) ti.datepicker('option', 'minDate', date);
   }
   maxcmp(e) {
      var row = $(e.currentTarget);
      var d = engine.row[row.data('id')];
      var r = engine.rowmap[d.dp.max_cmp.f];
      if (typeof r == 'undefined') return;
      var t = $('#table_engine #tb_' + r);
      var va = row.rVal();
      console.log('maxcmp');
      console.log(d.dp);
      var date = new Date(va.y + d.dp.max_cmp.y, va.m + d.dp.max_cmp.m, va.d + d.dp.max_cmp.d, 0, 0, 0, 0);
      console.log(date);
      date = engine.fn.formatYMD(date);
      var ti = t.find('input');
      ti.attr('max', date.replace(/\//g, '-'));
      if (ti.hasClass('hasDatepicker')) ti.datepicker('option', 'maxDate', date);
   }
   formatYMD(d) {
      var m = d.getMonth() + 1;
      if (m < 10) m = '0' + m;
      var n = d.getDate();
      if (n < 10) n = '0' + n;
      return d.getFullYear() + '-' + m + '-' + n;
   }
   num2focus(i) {
      if (i.is(':focus')) return;
      i.focus();
   }
   selcb_max(e) {
      var row = $(e.currentTarget);
      var max = engine.row[row.data('id')].max;
      if (!max) return;
      var nv = $(e.target).parent().find('input:checkbox').prop('checked') ? 0 : 1;
      if (nv == 0) return;
      var oc = row.find('input:checked');
      if (oc.length + nv > max) {
         e.stopPropagation();
      }
   }
   irsz2helyseg(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (e.type == 'keyup' && (va == null || va.length < 4)) return;
      var pre = engine.row[row.data('id')].pre;
      var hrow = $('#tb_' + pre + '_helyseg');
      if (va == hrow.data('loaded')) return;
      hrow.cmd('load_addr', {va: va, async: true}, function (row, o) {
         if (typeof o == 'undefined' || !o.success) return;
         var kv = o.l > 1 ? true : false;
         hrow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, kv)
            .selectmenu('refresh', true);
         if (o.l) hrow.setInputs('enable');
         else hrow.setInputs('disable');
         hrow.trigger('updatelayout').trigger('change');
      });
   }
   helyseg2utca(e) {
      var row = $(e.currentTarget);
      console.log('helyseg2utca', row);
      var va = row.rVal();
      var urow = $('#tb_' + engine.row[row.data('id')].pre + '_utca');
      if (va == urow.data('loaded')) return;
      urow.cmd('load_addr', {va: va, async: true}, function (row, o) {
         if (typeof o == 'undefined' || !o.success || o.opt == null) return;
         urow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) urow.setInputs('enable');
         else urow.setInputs('disable');
         urow.trigger('updatelayout').trigger('change');
      });
   }
   chk_num(e, args) {
      console.log('chk_num');
      var min = args[0], max = args[1], anull = args[2];
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (typeof (anull) != 'undefined' && anull != 0 && (va == null || !va.length)) return false;
      if (parseInt(va, 10) != va) return false;
      if (va < min || va > max) return false;
      return true;
   }
   chk_empty(e) {
      console.log('chk_empty');
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (va.length <= 0) return false;
      return true;
   }
   chk_reg(e, args) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (va == null || !va.length) return true;
      var r = new RegExp(args);
      if (!r.test(va)) return false;
      return true
   }
   chk_email(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (va == null || !va.length) return true;
      if (!engine.fn.chk_email_reg(va)) {
         row.trigger('rowError', 'inv');
         return false;
      }
      row.cmd('selfChk', {va: va});
//         engine.ajaxChk('email', va, row);
   }
   chk_email_reg(s) {
      return /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(s);
   }
// TODO: self lett
   chk_idcard(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (va == null || !va.length) return true;
      if (/^([A-Z]{2}[0-9]{6})|([0-9]{6}[A-Z]{2})|([A-Z]{2}[IVX]{1,4}[0-9]{6})$/.test(va)) return true;
      return false;
   }
   chk_anyjaneve(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      if (va == null || !va.length) return true;
      if (/^([A-Za-záéúóűöőüíÖÜÓŐÚÁŰÉÍ -.])+(\s[A-Za-záéúóűöőüíÖÜÓŐÚÁŰÉÍ]+)+$/.test(va)) return true;
      return false;
   }
   allowed_keys(k) {
      console.log(k);
      return $.inArray(parseInt(k), [8, 9, 13, 33, 34, 35, 36, 37, 38, 39, 40]) != -1; // ,99,118,120
   }
   csak_szig(e) {
      var c = e.which || e.keyCode;
      if (engine.fn.allowed_keys(c)) return;
      var c = String.fromCharCode(kc).replace(/[^A-Za-z0-9.-]/, '');
      if (c == '') return false;
   }
   only_number(e) {
      var c = e.which || e.keyCode;
      if (engine.fn.allowed_keys(c)) return;
      if (48 <= c && c <= 57) return;
      e.preventDefault();
   }
   only_alphanum(e) {
      var c = e.which || e.keyCode;
      if (engine.fn.allowed_keys(c)) return;
      if (((48 <= c && c <= 57) || (65 <= c && c <= 90) || (97 <= c && c <= 122))) return;
      e.preventDefault();
   }
   only_numAndAlph(e) {
      var c = e.which || e.keyCode;
      if (engine.fn.allowed_keys(c)) return;
      if ((48 <= c && c <= 57) || (65 <= c && c <= 90) || (97 <= c && c <= 122)) return;
      if (48 <= c && c <= 57) return;
      e.preventDefault();
   }
   only_email(e) {
      var c = e.which || e.keyCode;
      if (engine.fn.allowed_keys(c)) return;
      if (c == 64 || c == 45 || c == 46 || c == 95 || c == 43) return; //@-._+
      if ((48 <= c && c <= 57) || (65 <= c && c <= 90) || (97 <= c && c <= 122)) return;
      e.preventDefault();
   }
   only_tel(e) {
      var c = e.which || e.keyCode;
      if (engine.fn.allowed_keys(c)) return;
      if (c == 43 || c == 32) return;
      if (48 <= c && c <= 57) return;
      e.preventDefault();
   }
   santize_alpha(s) {
      return engine.fn.replace(s, '/[^a-zA-Z\s]/g', '');
   }
   replace(s, reg, n) {
      return (s + '').replace(reg, n);
   }
   strtoupper(e) {
      var row = $(e.currentTarget);
      row.rVal(row.rVal().toUpperCase());
      return true;
   }
   ucfirst(e) {
      var row = $(e.currentTarget);
      var va = row.rVal().toLowerCase() + '';
      var f = va.charAt(0).toUpperCase();
      row.rVal(f + va.substr(1));
      return true;
   }
   ucwords(e) {
      var row = $(e.currentTarget);
      var va = row.rVal().toLowerCase();
      if (va.indexOf('-') != -1) {
          if (va.indexOf(' ') == -1) {
              va = (va + '').replace('-', ' - ');
          }
      }
//          var vaArray = va.split('-');
//          var resArray = [];
//          $.each(vaArray, function(k, v) {
//              v = (v + '').replace(/^([a-záéíóöőúüű])|\s+([a-záéíóöőúüű])/g, function ($1) {
//                 resArray.push($1.toUpperCase());
//              });
//          });
//          va = resArray.join('-');
//      }
//      else {
          va = (va + '').replace(/^([a-záéíóöőúüű])|\s+([a-záéíóöőúüű])/g, function ($1) {
              return $1.toUpperCase()
          });
//      }
//      va = (va + '').replace(/^([a-z\u00E0-\u00FC])|\s+([a-z\u00E0-\u00FC])/g, function ($1) {
      
      row.rVal(va);
      return true;
   }
   addPopup(e) {
      var row = $(e.currentTarget);
      if (!row.rVal()) return;
      var id = engine.rowmap[row.data('id')];
      $('#pop_' + id).popup('open', {
         dismissible: true,
         history: false,
         transition: 'flip'
      });
   }
   format1k(d) {
      if( typeof d === 'undefined' || d === null ){
          return;
      }
      return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
   }
   make_amount(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      va = va.toString().replace(/ /g, '');
      var ret = engine.fn.format1k(va);
      return row.rVal(ret);
   }
   fadeChange(s, ts, t, rf) {
      s.fadeOut(500, 'linear', function () {
         var o = ts.html();
         ts.html(t);
         s.fadeIn(500, 'linear', function () {
            if (typeof rf == 'function') rf(o);
         });
      });
   }
   saveState() {
      if (typeof engine.saveState == 'function') return engine.saveState();

      console.log('saveState require.ensure');
      require.ensure(['./saveState'], function () {
         engine.saveState = require('./saveState').default;
         engine.saveState();
      });
   }
   callBack() {
      if (typeof engine.callBack == 'function') return engine.callBack();

      console.log('callBack require.ensure');
      require.ensure(['./callBack'], function () {
         engine.callBack = require('./callBack').default;
         engine.callBack();
      });
   }

   inlinepdf(row) {
      var PDFObject = require('pdfobject');
      let cb = (row) => {
         var did = engine.rowmap[row.data('id')];
         var u = engine.page['pdf'][did];
         $.each(u, function( index, value ) {
            $('#' + did).append("<div id="+did+"-"+index+"></div>")
            PDFObject.embed('//' + value, $('#' + did+'-'+index), {fallbackLink: "<iframe src='//docs.google.com/gview?url=" + value
               + "&embedded=true' frameborder='0'></iframe>"});
        });
      }
      if (typeof PDFObject == 'object') return cb(row);


      //console.log('PDFObject require.ensure');
/*      require.ensure(['PDFObject'], function (require) {
         PDFObject = require('pdfobject');
      });*/
      //alert('PDFObject'+ PDFObject.pdfobjectversion);
   }

   debug_init() {
      var sid = false;
      var show = function (r) {
         var o = $(r.wr).find('.' + r.class);
         if (o.length) {
            o.fadeOut(500, 'linear', function () {
               o.remove();
               $(r.wr).prepend(r.html);
            });
            return;
         }
         $(r.wr).prepend(r.html);
      };
      $('#debug_panel').on('click', 'button.getins', function () {
         if (!$('#debug_panel .tout').hasClass('init')) {
            $('#debug_panel .tout').addClass('init');
            $('#result-table tr').each(function () {
               var t = $(this);
               t.find('td.name div.name').append(' (' + t.data('id') + ')');
            });
         }
         var r = engine.ajaxFunc('deb', {cmd: 'loadTerms'});
         $(r.wr).html(r.html);
      }).on('click', '.tout button', function () {
         show(engine.ajaxFunc('deb', {cmd: 'getTO', id: $(this).data('id')}));
      }).on('click', '.session button', function () {
         show(engine.ajaxFunc('deb', {cmd: 'sess', t: $(this).data('t')}));
      }).on('click', '.sendsess', function () {
         show(engine.ajaxFunc('deb', {cmd: 'sendsess', m: $('#debug_panel input.mail').val()}));
      })
   }

   get_declaration(e) {
      var row = $(e.currentTarget);
      if(row.rVal() == 1) {
         var r = engine.ajaxFunc('declaration');
         engine.popMsg(r.html);
         e.stopPropagation();
      }
   }

   corrdate(e) {
      var row = $(e.currentTarget);
      var r = engine.rowmap[row.data('id')];
      if (typeof r == 'undefined') return;
      var t = $('#tb_' + r);
      var ival = row.rVal();
      var y = ival.y + '';
      var m = ((ival.m != null && !isNaN(ival.m)) ? ival.m : '') + '';
      var d = ((ival.d != null && !isNaN(ival.d)) ? ival.d : '') + '';

      if ((m*1 > 0 && m*1 < 10) || m*1 > 13) {
          m = '0' + m;
      }
      if ((d*1 > 0 && d*1 < 10) || d*1 > 31) {
          d = '0' + d;
      }

      var dat = '';
      var cuty = y;
      var cutm = m;
      var cutd = d;
      if (y.length == 8) {
          cuty = y.substring(0,4);
          cutm = y.substring(4,6);
          cutd = y.substring(6,8);
          var ti = t.find('input');
          if (ti.hasClass('hasDatepicker')) {
              dat = cuty + '-' + cutm + '-' + cutd;
              ti.datepicker('setDate', dat);
          }
      }
      if (y.length == 4 && m.length == 4) {
          cuty = y.substring(0,4);
          cutm = m.substring(0,2);
          cutd = m.substring(2);
          var ti = t.find('input');
          if (ti.hasClass('hasDatepicker')) {
              dat = cuty + '-' + cutm + '-' + cutd;
              ti.datepicker('setDate', dat);
          }
      }
      dat = cuty + '-' + cutm + '-' + cutd;
      var ti = t.find('input');
      if (ti.hasClass('hasDatepicker') && cuty && cutm && cutd) {
          ti.datepicker('setDate', dat);
      }
      console.log('datum: ', dat);
      if (/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(dat)) {
          row.trigger('rowError',false);
          return true;
      }
      row.trigger('rowError','inv');
      return false;
   }

   load_gyartmany(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var gyrow = $('#tb_' + pre + '_gyartmany');
      var eurow = $('#tb_' + pre + '_eurotax_alapjan');
      var mtrow = $('#tb_' + pre + '_motortipus');

      gyrow.cmd('load_gyartmany', {date: date, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         $('#gj_eurotax').val('');
         $('#tb_gj_eurotax_data').html('');
         gyrow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) {
             gyrow.setInputs('enable');
             eurow.setInputs('enable');
             mtrow.setInputs('enable');
         }
         else {
             gyrow.setInputs('disable');
             eurow.setInputs('disable');
             mtrow.setInputs('disable');
         }
         gyrow.trigger('updatelayout').trigger('change');
      });
   }

   load_motortipus(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      var gy = $('#gj_gyartmany').val();
      if (!gy || typeof gy == 'undefined' || gy == '-') {
          return;
      }
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var mtrow = $('#tb_' + pre + '_motortipus');
      mtrow.cmd('load_motortipus', {gy: gy, date: date, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         $('#gj_eurotax').val('');
         $('#tb_gj_eurotax_data').html('');
         mtrow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) mtrow.setInputs('enable');
         else mtrow.setInputs('disable');
         mtrow.trigger('updatelayout').trigger('change');
      });
   }

   load_tipus(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var gy = $('#gj_gyartmany').val();
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      console.log('gj_tipus_date', date);
      var mt = $('#gj_motortipus').val();
      if (va == -1) {
          $('#gj_kivitel').val();
          $('#gj_kivitel').html('');
          $('#gj_kivitel').hide();
      }
      if (!mt || typeof mt == 'undefined' || mt == '-' || mt == -1) {
          return;
      }
      var trow = $('#tb_' + pre + '_tipus');
      console.log('gj_tipus', trow);
//      if (va == trow.data('loaded')) return;
//      $('.ui-loader').css('display', 'block');
      trow.cmd('load_tipus', {gy: gy, date: date, mt: mt, async: false}, function (row, o) {
//         $('.ui-loader').css('display', 'none');
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         $('#gj_eurotax').val('');
         $('#tb_gj_eurotax_data').html('');
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (va != '-' && va != -1) engine.fn.load_kivitel(e);
   }

   load_cm3(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var t = $('#tb_gj_tipus');
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var mt = $('#gj_motortipus').val();
      if (va == -1) {
          $('#gj_kivitel').val();
          $('#gj_kivitel').html('');
          $('#gj_kivitel').hide();
      }
      if (!t.rVal() || typeof t.rVal() == 'undefined' || t.rVal() == '-' || t.rVal() == -1) {
          console.log('load_cm3 kiszáll', t.rVal());
          return;
      }
      var trow = $('#tb_' + pre + '_cm3');
//      if (va == trow.data('loaded')) return;
      trow.cmd('load_cm3', {t: t.rVal(), date: date, mt: mt, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         var kv = false;
         if (o.opt[-1] && typeof o.opt[-1] != 'undefined') {
             if (o.l > 2) kv = true;
         }
         else {
             if (o.l > 1) kv = true;
         }
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, kv)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (va != '-' && va != -1) engine.fn.load_kivitel(e);
   }

   load_kw(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var t = $('#gj_tipus').val();
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var mt = $('#gj_motortipus').val();
      var cm = $('#gj_cm3').val();
      if (va == -1) {
          $('#gj_kivitel').val();
          $('#gj_kivitel').html('');
          $('#gj_kivitel').hide();
      }
      if (typeof cm == 'undefined' /*|| cm == '-'*/ || cm == -1) {
          console.log('load_kw kiszáll', cm);
          return;
      }
      var trow = $('#tb_' + pre + '_kw');
//      if (va == trow.data('loaded')) return;
      trow.cmd('load_kw', {t: t, date: date, mt: mt, cm: cm, async: false}, function (row, o) {
         var kv = false;
         console.log('kw opt: ', o);
         if (o.opt[-1] && typeof o.opt[-1] != 'undefined') {
             if (o.l > 2) kv = true;
         }
         else {
             if (o.l > 1) kv = true;
         }
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, kv)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (/*va != '-' &&*/ va != -1) engine.fn.load_kivitel(e);
   }

   load_szallszem(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var t = $('#gj_tipus').val();
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var mt = $('#gj_motortipus').val();
      var cm = $('#gj_cm3').val();
      var kw = $('#gj_kw').val();
      if (va == -1) {
          $('#gj_kivitel').val();
          $('#gj_kivitel').html('');
          $('#gj_kivitel').hide();
      }
      if (!kw || typeof kw == 'undefined' /*|| kw == '-'*/ || kw == -1) {
          console.log('load_szallszem kiszáll', kw);
          return;
      }
      var trow = $('#tb_' + pre + '_szallszem');
//      if (va == trow.data('loaded')) return;
      trow.cmd('load_szallszem', {t: t, date: date, mt: mt, cm: cm, kw: kw, async: false}, function (row, o) {
         if (typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         var kv = false;
         if (o.opt[-1] && typeof o.opt[-1] != 'undefined') {
             if (o.l > 2) kv = true;
         }
         else {
             if (o.l > 1) kv = true;
         }
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, kv)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (/*va != '-' &&*/ va != -1) engine.fn.load_kivitel(e);
   }

   load_sajattomeg(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var t = $('#gj_tipus').val();
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var mt = $('#gj_motortipus').val();
      var cm = $('#gj_cm3').val();
      var kw = $('#gj_kw').val();
      var fo = $('#gj_szallszem').val();
      if (va == -1) {
          $('#gj_kivitel').val();
          $('#gj_kivitel').html('');
          $('#gj_kivitel').hide();
      }
      if (typeof fo == 'undefined' /*|| fo == '-'*/ || fo == -1) {
          console.log('load_sajattomeg kiszáll', fo);
          return;
      }
      var trow = $('#tb_' + pre + '_sajattomeg');
//      if (va == trow.data('loaded')) return;
      trow.cmd('load_sajattomeg', {t: t, date: date, mt: mt, cm: cm, kw: kw, fo: fo, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         var kv = false;
         if (o.opt[-1] && typeof o.opt[-1] != 'undefined') {
             if (o.l > 2) kv = true;
         }
         else {
             if (o.l > 1) kv = true;
         }
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, kv)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (/*va != '-' &&*/ va != -1) engine.fn.load_kivitel(e);
   }

   load_ossztomeg(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var pre = engine.row[row.data('id')].pre;
      var t = $('#gj_tipus').val();
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var mt = $('#gj_motortipus').val();
      var cm = $('#gj_cm3').val();
      var kw = $('#gj_kw').val();
      var fo = $('#gj_szallszem').val();
      var st = $('#gj_sajattomeg').val();
      if (va == -1) {
          $('#gj_kivitel').val();
          $('#gj_kivitel').html('');
          $('#gj_kivitel').hide();
      }
      if (typeof fo == 'undefined' /*|| fo == '-'*/ || fo == -1) {
          console.log('load_ossztomeg kiszáll', fo);
          return;
      }
      var trow = $('#tb_' + pre + '_ossztomeg');
//      if (va == trow.data('loaded')) return;
      trow.cmd('load_ossztomeg', {t: t, date: date, mt: mt, cm: cm, kw: kw, fo: fo, st: st, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         var kv = false;
         if (o.opt[-1] && typeof o.opt[-1] != 'undefined') {
             if (o.l > 2) kv = true;
         }
         else {
             if (o.l > 1) kv = true;
         }
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, kv)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
         
      });
      if (/*va != '-' &&*/ va != -1) engine.fn.load_kivitel(e);
   }

   load_kivitel(e) {
      var eurotax_alapjan = $('#tb_gj_eurotax_alapjan');
      var row_t = $('#tb_gj_tipus');
      var row_cm = $('#tb_gj_cm3');
      var row_kw = $('#tb_gj_kw');
      var row_fo = $('#tb_gj_szallszem');
      var row_st = $('#tb_gj_sajattomeg');
      var row_ot = $('#tb_gj_ossztomeg');
      var row_mt = $('#tb_gj_motortipus');
      var fajta = engine.ajaxFunc('get_session_val', {'id': 'gj_fajta_gfb'}, false);
      var trow = $('#tb_gj_kivitel');
      var t = row_t.rVal();
      var cm = row_cm.rVal();
      var kw = row_kw.rVal();
      var fo = row_fo.rVal();
      var st = row_st.rVal();
      var mt = row_mt.rVal();
      var ot = row_ot.rVal();

      console.log('load_kivitel: ',row_t.is(':visible'),t,' ',row_cm.is(':visible'),cm, ' ', row_kw.is(':visible'),kw, ' ', row_fo.is(':visible'),fo, ' ', row_st.is(':visible'),st, ' ', row_mt.is(':visible'),mt, ' ', row_ot.is(':visible'),ot);
      if (typeof t == 'undefined' || (t == -1 && row_t.is(':visible'))
              || typeof cm == 'undefined' || (cm == -1 && row_cm.is(':visible'))
              || typeof kw == 'undefined' || (kw == -1 && row_kw.is(':visible'))
              || typeof fo == 'undefined' || (fo == -1 && row_fo.is(':visible'))
              || typeof st == 'undefined' || (st == -1 && row_st.is(':visible') && fajta.value != 3)
              || typeof mt == 'undefined' || (mt == -1 && row_mt.is(':visible'))
              || typeof ot == 'undefined' || (ot == -1 && row_ot.is(':visible') && fajta.value != 3)
              || eurotax_alapjan.rVal() == 1) {
          trow
            .html('');
          trow.hide();
          return;
      }
      if (fajta.value == 3 && !row_st.is(':visible')) {
          trow
            .html('');
          trow.hide();
          return;
      }
      trow.cmd('load_kivitel', {t: t, cm: cm, kw: kw, fo: fo, st: st, mt: mt, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o == 'undefined' || !o.success) {
             trow
               .html('');
             trow.hide();
             return;
         }
         if (!o.l) {
             trow
               .html('');
             trow.hide();
             return;
         }
         trow.show();
         trow
            .html(o.opt);
         trow.trigger('create');
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
//         trow.trigger('updatelayout').trigger('change');
         engine.fn.getSzeria();
      });
   }

   getSzeria(e) {
      $('.modell-select').on('click tap', function (e){
//         var row = $(e.currentTarget);
//         var pre = engine.row[row.data('id')].pre;
         var ev = $('#gj_datum_ev').val();
         var ho = $('#gj_datum_ho').val();
         if (ev && ho) var date = ev + '-' + ho + '-' + '01';
         else var date = '';
         var va = $(this).attr('id').replace('bovebben-', '');
         var trow = $('#tb_gj_kivitel');

         if (!va) {
             console.log('szeria: nincs va');
             return;
         }
         console.log('szeria: van va');
         trow.cmd('load_szeria', {eurotax: va, date: date, async: false}, function (row, o) {
            if (typeof o == 'undefined' || !o.success) return;
            engine.popMsg(o.opt);
            e.stopPropagation();
         });
      });

      $('#gj_kivitel').on('change', function () {
         var row = $('#tb_gj_kivitel');
         var krow = $('#tb_gj_kiemelt_extra');
         var et = $("input[name='gj_kivitel']:checked").val();
         var ev = $('#gj_datum_ev').val();
         var ho = $('#gj_datum_ho').val();
         var hidden_row = $('#tb_gj_szeria_hidden');

         if (typeof hidden_row.rVal() == 'undefined' || !hidden_row.rVal() || hidden_row.rVal() != et) {
             if (ev && ho) var date = ev + '-' + ho + '-' + '01';
             else var date = '';

             if (!et || typeof et == 'undefined') {
                 et = $('#gj_eurotax').val();
             }

             $('#gj_szeria_hidden').val(et);
             if (et.length == 8) {
                 row.cmd('load_szeria', {eurotax: et, date: date, async: false}, function (row, o) {
                    if (typeof o == 'undefined' || !o.success) return;
                 });
//                 engine.fn.getExtra();
//                 engine.fn.getCsomagExtra();
//                 engine.fn.extra_array();
             }
         }
      });
      return;
   }

   getExtra(e) {
      var et = $("input[name='gj_kivitel']:checked").val();
      $('#gj_kivitel_hidden').val(et);
      var trow = $('#tb_gj_extra');

      if (!et || et == 'undefined' || $('#tb_gj_kivitel').is(':hidden')) {
          et = $('#gj_eurotax').val();
          console.log('extra_et', et, 'et_hossz: ', et.length);
      }

      if (($('#tb_gj_kivitel').is(':hidden') || typeof et == 'undefined') && (!et || et.length != 8)) {
          trow.hide();
          trow.setInputs('disable');
          return;
      }
      var row = $('#tb_gj_kivitel');
      var va = row.rVal();
      if (!va) {
          row = $('#tb_gj_eurotax');
          va = row.rVal();
      }

      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';

      trow.cmd('load_extra', {et: et, date: date, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o == 'undefined' || !o.success || o.opt.length == 0) {
             trow.hide();
             return;
         }
         var r = engine.rowmap[row.data('id')];
         var sv = engine.ajaxFunc('get_session_val', {'id': r}, false);
         trow.show();
         if(va != 'undefined') trow.data('loaded', va);
            trow.find('select').selSetOp(o.opt, true, sv.value, 'Nincs')
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
//         trow.trigger('updatelayout').trigger('change');
      });
   }
   getCsomagExtra(e) {
      var et = $("input[name='gj_kivitel']:checked").val();
      $('#gj_kivitel_hidden').val(et);
      var trow = $('#tb_gj_csomag_extra');
      if (!et || et == 'undefined' || $('#tb_gj_kivitel').is(':hidden')) {
          et = $('#gj_eurotax').val();
      }
      if (($('#tb_gj_kivitel').is(':hidden') || typeof et == 'undefined') && (!et || et.length != 8)) {
          trow.hide();
          trow.setInputs('disable');
          return;
      }
      var row = $('#tb_gj_kivitel');
      var va = row.rVal();

      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';

      trow.cmd('load_csomag_extra', {et: et, date: date, async: false}, function (row, o) {
          console.log('csomag_ajax: ', o);
         if (!$.isPlainObject(o) || typeof o == 'undefined' || !o.success || o.opt.length == 0) {
             trow.hide();
             return;
         }
         var r = engine.rowmap[row.data('id')];
         var sv = engine.ajaxFunc('get_session_val', {'id': r}, false);
         trow.show();
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true, sv.value, 'Nincs')
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
//         trow.trigger('updatelayout').trigger('change');
      });
   }

   extra_array(e) {
//      $('#gj_kivitel').on('change', function () {
//      if($.isPlainObject(e)) {
//          var ch = $(e.currentTarget);
//          var chrow = engine.rowmap[ch.data('id')];
//      }
//      else {
//          var chrow = $('#gj_kivitel');
//      }
//      chrow.on('change', function () {
          var et = $("input[name='gj_kivitel']:checked").val();
          $('#gj_kivitel_hidden').val(et);
          var krow = $('#tb_gj_kiemelt_extra');
          var kva = krow.rVal();
          var trow = $('#tb_gj_csomag_extra');
          var row = $('#tb_gj_extra');
          var kivrow = $('#tb_gj_kivitel');
          var etalap = $('#gj_eurotax_alapjan').val();
          var va = row.rVal();
          var csva = trow.rVal();

          var data = engine.row[krow.data('id')].loaded;
          console.log('extra data loaded ', data);
          
          if ((!et || et == 'undefined' || et == -1) && etalap == 1) {
              et = $('#gj_eurotax').val();
              console.log('gj_eurotax érték', et);
          }
          if (!et || et.length != 8) {
              $("input[name^='gj_kiemelt_extra']").each(function () {
                 $(this).removeAttr('checked');
                 $(this).removeAttr('disabled');
              });
              krow.find("input[type='checkbox']").checkboxradio('refresh');
              
              if (data && data != 'undefined') {
                  $.each(data, function(ext, evalue) {
                      $("input[name='gj_kiemelt_extra[" + evalue + "]'").prop('checked', true);
                      krow.find("input[type='checkbox']").checkboxradio('refresh');
                  });
              }
              return;
          }

          var ev = $('#gj_datum_ev').val();
          var ho = $('#gj_datum_ho').val();
          if (ev && ho) var date = ev + '-' + ho + '-' + '01';
          else var date = '';


          kivrow.cmd('load_szeria_array', {et: et, date: date, async: false}, function (row, k) {
              $("input[name^='gj_kiemelt_extra']").each(function () {
                 if ($(this).is(':disabled') || !$(this).is(':checked')) {
                     $(this).removeAttr('checked');
                     $(this).removeAttr('disabled');
                 }
              });
              
              krow.find("input[type='checkbox']").checkboxradio('refresh');
              if (typeof k != 'undefined' && k.success) {
                  var sz = k.sz;

                  trow.cmd('load_extra_array', {et: et, date: date, e: va, cse:csva, sz:sz, async: false}, function (row, o) {
                      if (typeof o != 'undefined' && o.success) {
        //                  krow.data('loaded', kva);
                          krow.find("input[type='checkbox']").checkboxradio('refresh');
                          $.each(o.e, function (k, v) {
        //                     if ($.inArray(k, krow.data('loaded')) == -1) {
                                 if (v != null && v.length) {
                                    $("input[name='gj_kiemelt_extra[" + v + "]'").prop('checked', true);
                                    $("input[name='gj_kiemelt_extra[" + v + "]'").attr('disabled', true);
                                    krow.find("input[type='checkbox']").checkboxradio('refresh');
                                 }
                                 else {
                                    $("input[name='gj_kiemelt_extra[" + v + "]'").removeAttr('checked');
                                    $("input[name='gj_kiemelt_extra[" + v + "]'").removeAttr('disabled');
                                    krow.find("input[type='checkbox']").checkboxradio('refresh');
                                 }
        //                     }
                          });
                      }
                  });
              }
          });
          
          if (data && data != 'undefined') {
              $.each(data, function(ext, evalue) {
                  $("input[name='gj_kiemelt_extra[" + evalue + "]'").prop('checked', true);
                  krow.find("input[type='checkbox']").checkboxradio('refresh');
              });
          }
          
//      });


//      $('document').ready(function () {
//          var et = $("input[name='gj_kivitel']:checked").val();
//          $('#gj_kivitel_hidden').val(et);
//          var krow = $('#tb_gj_kiemelt_extra');
//          var trow = $('#tb_gj_csomag_extra');
//          var row = $('#tb_gj_extra');
//          var kivrow = $('#tb_gj_kivitel');
//          var va = row.rVal();
//          var csva = trow.rVal();
//
//          console.log('gj_kivitel érték', et);
//
//          if (!et || et == 'undefined') {
//              et = $('#gj_eurotax').val();
//              console.log('gj_eurotax érték', et);
//          }
//          if (et.length != 8) {
//              $("input[name^='gj_kiemelt_extra']").each(function () {
//                 $(this).prop('checked', false);
//                 $(this).removeAttr('disabled');
//              });
//              krow.find("input[type='checkbox']").checkboxradio('refresh');
//              return;
//          }
//          var ev = $('#gj_datum_ev').val();
//          var ho = $('#gj_datum_ho').val();
//          if (ev && ho) var date = ev + '-' + ho + '-' + '01';
//          else var date = '';
//
//          kivrow.cmd('load_szeria_array', {et: et, date: date, async: true}, function (row, k) {
//              $("input[name^='gj_kiemelt_extra']").each(function () {
//                 $(this).prop('checked', false);
//                 $(this).removeAttr('disabled');
//              });
//              krow.find("input[type='checkbox']").checkboxradio('refresh');
//              if (typeof k == 'undefined' || !k.success) return;
//              var sz = k.sz;
//
//              trow.cmd('load_extra_array', {et: et, date: date, e: va, cse:csva, sz:sz, async: true}, function (row, o) {
//                  if (typeof o == 'undefined' || !o.success) return;
//                  krow.find("input[type='checkbox']").checkboxradio('refresh');
//                  $.each(o.e, function (k, v) {
//                     if (v != null && v.length) {
//                        $("input[name='gj_kiemelt_extra[" + v + "]'").prop('checked', true);
//                        $("input[name='gj_kiemelt_extra[" + v + "]'").attr('disabled', true);
//                        krow.find("input[type='checkbox']").checkboxradio('refresh');
//                     }
//                  });
//              });
//          });
//      });
   }
 
   get_extra_ertek() {
      $("input[name^='gj_kiemelt_extra']").each(function () {
         if ($(this).is(':disabled')) {
             $('#tb_gj_' + $(this).val() + '_ar').css('display','none');
             $('#tb_gj_' + $(this).val() + '_ar').hide();
         }
//         else {
//             $('#tb_gj_' + $(this).val() + '_ar').css('display','');
//             $('#tb_gj_' + $(this).val() + '_ar').show();
//         }
      }); 
   }
   
   disableExtra(e) {
       var row = $(e.currentTarget);
       var va = row.rVal();
       var kiv = $('#gj_kivitel').val();
       if (!kiv || typeof kiv == 'undefined') kiv = '';
       var eur = $('#gj_eurotax').val();
       if (!eur || typeof eur == 'undefined') eur = '';
       if (kiv.length != 8 || eur.length != 8) {
           $('#tb_gj_csomag_extra').hide();
           $('#tb_gj_extra').hide();
       }
       return;
   }
   chk_kivitel(e) {
       $('form').on('click','.next', function (){
           console.log('gj submit');
           var row = $('#tb_gj_kivitel');
           var r = engine.rowmap[row.data('id')];
           var kiv = $("input[name='gj_kivitel']:checked").val();
           var et_hidden = $('#gj_eurotax').val();
           var gj_row = $('#tb_gj');
           var et_alapjan = $('#gj_eurotax_alapjan').val();
           var gj_tip = $('#gj_tipus').val();
           var gj_eurotax_data = $('#tb_gj_eurotax_data');
     
           if (et_alapjan == 1 && et_hidden.length == 8) {
               if (gj_eurotax_data.html() == 'Kérjük ellenőrizze az adatokat!') {
                   gj_row.trigger('rowError','inv');
                   $('#tb_gj').scrollToMe();
                   return false;
               }
               else {
                   return true;
               }
           }

           if (kiv == '') {
               kiv = et_hidden;
               if ((kiv == '') && gj_tip != -1) {
                   console.log('kivitel', kiv);
                   gj_row.trigger('rowError','inv');
                   $('#gj_kivitel').scrollToMe();
                   return false;
               }
           }
           else if (kiv == 'NT' || typeof kiv == 'undefined') {
               console.log('kivitel', kiv);
               var cm_row = $('#tb_gj_cm3');
               var kw_row = $('#tb_gj_kw');
               var sz_row = $('#tb_gj_szallszem');
               var st_row = $('#tb_gj_sajattomeg');
               var cm_egyeb_row = $('#tb_gj_cm3_egyeb');
               var kw_egyeb_row = $('#tb_gj_kw_egyeb');
               var sz_egyeb_row = $('#tb_gj_szallszem_egyeb');
               var st_egyeb_row = $('#tb_gj_sajattomeg_egyeb');
               var cm = cm_row.rVal();
               var kw = kw_row.rVal();
               var sz = sz_row.rVal();
               var st = st_row.rVal();
               var cm_egyeb = cm_egyeb_row.rVal();
               var kw_egyeb = kw_egyeb_row.rVal();
               var sz_egyeb = sz_egyeb_row.rVal();
               var st_egyeb = st_egyeb_row.rVal();
               console.log('chk_kivitel: cm:', cm, ' cm_egyeb:', cm_egyeb, ' kw:',kw, ' kw_egyeb:', kw_egyeb, ' sz:', sz, ' sz_egyeb:', sz_egyeb, ' st:', st, ' st_egyeb:', st_egyeb, ' kivitel: ', kiv);
               if (cm >= 0 && kw > 0 && sz >= 0 && st > 0 && typeof kiv == 'undefined') {
                   row.trigger('rowError','inv');
                   $('#gj_kivitel').scrollToMe();
                   return false;
               }
//               if (((cm >= 0 || cm_egyeb >= 0) && cm != '-') && ((kw > 0 || kw_egyeb > 0) && kw != '-') && ((sz > 0 || sz_egyeb > 0) && sz != '-') && ((st > 0 || st_egyeb > 0) && st != '-')) {
//                   console.log('továbbengedi');
//                   return true;
//               }
               if (((typeof cm == 'undefined' || cm === null || cm == '-' || cm_row.is(':hidden')) && (typeof cm_egyeb == 'undefined' || cm_egyeb === null || cm_egyeb_row.is(':hidden'))) || 
                       ((typeof kw == 'undefined' || kw <= 0 || kw == '-' || kw_row.is(':hidden')) && (typeof kw_egyeb == 'undefined' || kw_egyeb <= 0 || kw_egyeb_row.is(':hidden'))) ||
                       ((typeof sz == 'undefined' || sz < 0 || sz == '-' || sz_row.is(':hidden')) && (typeof sz_egyeb == 'undefined' || sz_egyeb <= 0 || sz_egyeb_row.is(':hidden'))) || 
                       ((typeof st == 'undefined' || st < 0 || st == '-' || st_row.is(':hidden')) && (typeof st_egyeb == 'undefined' || st_egyeb <= 0 || st_egyeb_row.is(':hidden')))) {
                   row.trigger('rowError','inv');
                   $('#gj_kivitel').scrollToMe();
                   return false;
               }
//               else {
//                   row.trigger('rowError','inv');
//                   $('#gj_kivitel').scrollToMe();
//                   return false;
//               }
           }
           engine.ajaxFunc('set_select_val', {'id': r, 'val': kiv}, false);
           return true;
       });
   }

   storeAjaxSelect(e){
      var row = $(e.currentTarget);
      var va = row.rVal();
      var r = engine.rowmap[row.data('id')];
      var trow = $('#tb_' + r);
      if (va == trow.data('loaded')) return;

      if(r && va) {
         engine.ajaxFunc('set_select_val', {'id': r, 'val': va});
      }
   }
   
   getTeaor_0(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();

      var crow = $('#tb_szerzodo');
      var trow = $('#tb_szerzodo_teaor_0');
      if ($('#tb_szerzodo_teaor_ev') != 'undefined') {
          var evrow = $('#tb_szerzodo_teaor_ev');
          var ev = evrow.rVal();
      }
      else {
          var ev = 2008;
      }
      if (va == trow.data('loaded')) return;
      crow.cmd('load_teaor_0', {p: -1, ev: ev, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (va) engine.fn.getTeaor_1(e);
   }

   getTeaor_1(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var tarow = $('#tb_szerzodo_teaor_0');
      var ta = tarow.rVal();

      var crow = $('#tb_szerzodo');
      var trow = $('#tb_szerzodo_teaor_1');
      if ($('#tb_szerzodo_teaor_ev') != 'undefined') {
          var evrow = $('#tb_szerzodo_teaor_ev');
          var ev = evrow.rVal();
      }
      else {
          var ev = 2008;
      }

      if (va == trow.data('loaded')) return;
      crow.cmd('load_teaor_1', {p: ta, ev: ev, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (va) engine.fn.getTeaor_2(e);
   }

   getTeaor_2(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var tbrow = $('#tb_szerzodo_teaor_1');
      var tb = tbrow.rVal();

      var crow = $('#tb_szerzodo');
      var trow = $('#tb_szerzodo_teaor_2');
      if ($('#tb_szerzodo_teaor_ev') != 'undefined') {
          var evrow = $('#tb_szerzodo_teaor_ev');
          var ev = evrow.rVal();
      }
      else {
          var ev = 2008;
      }
      if (va == trow.data('loaded')) return;
      crow.cmd('load_teaor_2', {p: tb, ev: ev, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
      if (va) engine.fn.getTeaor_3(e);
   }

   getTeaor_3(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var tcrow = $('#tb_szerzodo_teaor_2');
      var tc = tcrow.rVal();

      var trow = $('#tb_szerzodo_teaor_3');
      var crow = $('#tb_szerzodo');
      if ($('#tb_szerzodo_teaor_ev') != 'undefined') {
          var evrow = $('#tb_szerzodo_teaor_ev');
          var ev = evrow.rVal();
      }
      else {
          var ev = 2008;
      }
      if (va == trow.data('loaded')) return;
      crow.cmd('load_teaor_3', {p: tc, ev: ev, async: false}, function (row, o) {
         if (!$.isPlainObject(o) || typeof o != 'object' || typeof o == 'undefined' || !o.success) return;
         trow
            .data('loaded', va)
            .find('select').selSetOp(o.opt, true)
            .selectmenu('refresh', true);
         if (o.l) trow.setInputs('enable');
         else trow.setInputs('disable');
         trow.trigger('updatelayout').trigger('change');
      });
   }

   teaor_back(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var trow = $('#tb_szerzodo_teaor');
      trow.find('text')
              .val(va);
      trow.trigger('updatelayout').trigger('change');
      if (va != '-') $('#szerzodo_teaor').val(va);
      else $('#szerzodo_teaor').val('');
   }

   teaor_fill(e) {
      var row = $(e.currentTarget);
      var va = row.rVal();
      var trow = $('#szerzodo_teaor');
      var controw = $('#tb_szerzodo');
      var arow = $('#tb_szerzodo_teaor_1');
      var brow = $('#tb_szerzodo_teaor_2');
      var crow = $('#tb_szerzodo_teaor_3');
      var drow = $('#tb_szerzodo_teaor_0');
      if ($('#tb_szerzodo_teaor_ev') != 'undefined') {
          var evrow = $('#tb_szerzodo_teaor_ev');
          var ev = evrow.rVal();
      }
      else {
          var ev = 2008;
      }

      if (va.length == 4 || (va.length == 5 && va.indexOf('.') > -1)) {
          if (va.length == 5 && va.indexOf('.') > -1) {
              var st = va;
          }
          else {
              if (va.indexOf('.') == -1) {
                  var res = va.split('');
                  var st = res[0] + res[1] + '.' + res[2] + res[3];
              }
              else st = va;
          }
          trow.val(st);

          controw.cmd('teaor_back', {p: st, ev: ev, async: false}, function (row, o) {
             if (typeof o == 'undefined' || !o.success) {
                 arow.find('select').val('-').selectmenu('refresh', true);
                 brow.find('select').val('-').selectmenu('refresh', true);
                 crow.find('select').val('-').selectmenu('refresh', true);
                 drow.find('select').val('-').selectmenu('refresh', true);
                 return;
             }
             var pa = o.opt[st];
             var pb = o.opt[pa];
             var pc = o.opt[pb];

             drow.find('select')
                     .val(pc)
                     .selectmenu('refresh', true);

             controw.cmd('load_teaor_1', {p: pc, ev: ev, async: false}, function (row, o) {
                 if (typeof o == 'undefined' || !o.success) return;
                 arow
//                    .data('loaded', va)
                    .find('select').selSetOp(o.opt, true)
                    .val(pb)
                    .selectmenu('refresh', true);
                 if (o.l) arow.setInputs('enable');
                 else arow.setInputs('disable');
             });
             controw.cmd('load_teaor_2', {p: pb, ev: ev, async: false}, function (row, o) {
                 if (typeof o == 'undefined' || !o.success) return;
                 brow
//                    .data('loaded', va)
                    .find('select').selSetOp(o.opt, true)
                    .val(pa)
                    .selectmenu('refresh', true);
                 if (o.l) brow.setInputs('enable');
                 else brow.setInputs('disable');
             });
             controw.cmd('load_teaor_3', {p: pa, ev: ev, async: false}, function (row, o) {
                 if (typeof o == 'undefined' || !o.success) return;
                 crow
//                    .data('loaded', va)
                    .find('select').selSetOp(o.opt, true)
                    .val(st)
                    .selectmenu('refresh', true);
                 if (o.l) crow.setInputs('enable');
                 else crow.setInputs('disable');
             });
          });
      }
   }

   storeTeaor() {
      var ta = $('#szerzodo_teaor').val();
      console.log('ta', ta);
      if (ta) engine.ajaxFunc('set_select_val', {'id': 'szerzodo_teaor', 'val': ta});
      var tb = $('#szerzodo_teaor_0').val();
      console.log('tb', tb);
      if (tb) engine.ajaxFunc('set_select_val', {'id': 'szerzodo_teaor_0', 'val': tb});
      var tc = $('#szerzodo_teaor_1').val();
      console.log('tc', tc);
      if (tc) engine.ajaxFunc('set_select_val', {'id': 'szerzodo_teaor_1', 'val': tc});
      var td = $('#szerzodo_teaor_2').val();
      console.log('td', td);
      if (td) engine.ajaxFunc('set_select_val', {'id': 'szerzodo_teaor_2', 'val': td});
      var te = $('#szerzodo_teaor_3').val();
      console.log('te', te);
      if (te) engine.ajaxFunc('set_select_val', {'id': 'szerzodo_teaor_3', 'val': te});
   }

   fill_eurotax(e) {
      var row = $('#tb_gj_eurotax');
      var trow = $('#tb_gj');
      var erow = $('#tb_gj_eurotax_data');
      var ev = $('#gj_datum_ev').val();
      var ho = $('#gj_datum_ho').val();
      if (ev && ho) var date = ev + '-' + ho + '-' + '01';
      else var date = '';
      var earow = $('#tb_gj_eurotax_alapjan');
      var csrow = $('#tb_gj_extra');
      var exrow = $('#tb_gj_csomag_extra');

      var va = row.rVal();
      var ea = earow.rVal();

      console.log('fill_eurotax: ', va, ea);

      if(va.length == 8 && ea == 1) {
          console.log('fill_eurotax ajax elott: ', va);
          trow.cmd('fill_eurotax', {et: va, date: date, async: true}, function (row, o) {
             console.log('fill_eurotax ajax: ', o);
             if (!$.isPlainObject(o) || typeof o == 'undefined' || !o.success) {
                 console.log('fill_eurotax ajax nincs talalat: ', o);
                 erow.show();
                 erow.html(o.opt);
                 csrow.hide();
                 exrow.hide();
                 erow.trigger('create');
                 erow.trigger('updatelayout').trigger('change');
                 return;
             }
             
             $('#gj_kivitel').val(va);
             erow.show();
             erow
                .html(o.opt);
             erow.trigger('create');
             erow.trigger('updatelayout').trigger('change');
             engine.fn.getExtra();
             engine.fn.getCsomagExtra();
             engine.fn.extra_array();
          });
      }
      else {
          erow.hide();
          erow.html('');
          erow.trigger('create');
          erow.trigger('updatelayout').trigger('change');
      }
   }

   numberlength(e) {
      $('input[type=number][max]:not([max=""])').on('input', function(ev) {
         var $this = $(this);
         var maxlength = $this.attr('max').length;
         var value = $this.val();
         if (value && value.length >= maxlength) {
            $this.val(value.substr(0, maxlength));
         }
      });
   }

   get_tanacsadas(){
      $('#tb_adatvedelmi a.get_tanacsadas').on('click', function(e){
          var text = "A tanácsadás nélküli online értékesítés során a CLB azzal segíti, hogy az Ügyfél az igényeinek és szükségleteinek leginkább megfelelő biztosítás kiválaszthassa, hogy a biztosításokat összehasonlító weboldalán a CLB elérhetővé, letölthetővé teszi a biztosításokhoz tartozó egységesített biztosítási termékismertetőket, a részletes biztosítási feltételeket, a biztosító és felügyeleti hatósága főbb adatait valamint az ügyfél által elérhető egy úgynevezett összehasonlítás funkció, ahol korlátozott számú paraméterekkel összehasonlíthatóak az elérhető termékek.<br><br>A tanácsadás nélküli online biztosítás értékesítés során tehát a CLB  személyre szabott - bizonyos biztosítási termék vagy termékek választására irányuló - konkrét ajánlást nem nyújt az Ügyfél részére, vagyis nem ismerteti, hogy az adott termék miért felel meg leginkább az adott terméket önállóan kiválasztó Ügyfél igényeinek és szükségleteinek.";
          engine.popMsg(text);
          e.stopPropagation();
      });
   }

   szerzodo_check() {
      if ($('#tb_szerzodo_email_1').is(':visible')) {
          var row = $('#tb_szerzodo_email_1');
      }
      else if ($('#tb_szerzodo_email_1_').is(':visible')) {
          var row = $('#tb_szerzodo_email_1_');
      }
      
      var szerzodo_neme = engine.row[row.data('id')].szerzodo_neme;

      if (szerzodo_neme = undefined || szerzodo_neme == '') {
          szerzodo_neme = $('#szerzodo_neme').val();
      }

      szerzodo_neme = szerzodo_neme * 1;
      var data = {
          szerzodo_email : engine.row[row.data('id')].szerzodo_email,
          szerzodo_u_emil : engine.row[row.data('id')].szerzodo_u_emil,
          szerzodo_neme : szerzodo_neme,
          dealer_email : engine.row[row.data('id')].dealer_u_emil,
          dealer_adoszam : engine.row[row.data('id')].dealer_adoszam,
          szerzodo_adoszam : engine.row[row.data('id')].szerzodo_adoszam,
          dealer_winliz_id : engine.row[row.data('id')].dealer_winliz_id,
          szerzodo_winliz_id : engine.row[row.data('id')].szerzodo_winliz_id,
          szerzodo_szn : engine.row[row.data('id')].szerzodo_szn,
          szerzodo_igszam : engine.row[row.data('id')].szerzodo_igszam,
          kedv_340 : engine.row[row.data('id')].kedv_340,
          kedv_76 : engine.row[row.data('id')].kedv_76,
          bizt : engine.row[row.data('id')].gfb_bizt,
          cbizt : engine.row[row.data('id')].casco_bizt,
          ker_ert_csat : engine.row[row.data('id')].ker_ert_csat,
      };
      $(engine.settings.form.id).on('click','.next', function (e, c){
          var szerzodo_email_1 = $('#szerzodo_email_1').val();
          if (typeof szerzodo_email_1 == 'undefined' || !szerzodo_email_1 || szerzodo_email_1 == '') {
              szerzodo_email_1 = $('#szerzodo_email_1_').val();
          }

          var confirmed = [];
          confirmed.push(c);
          
          if (typeof data.szerzodo_email != 'undefined' && data.szerzodo_email != '' && data.szerzodo_email) {
              if((szerzodo_email_1 && data.szerzodo_email != szerzodo_email_1 && data.szerzodo_email != '' && szerzodo_email_1 != '')) {
                  e.preventDefault();
                  var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>A korábban megadott (kedvezményes oldalon) email cím (" + data.szerzodo_email + ") nem egyezik az itt megadott email címmel (" + szerzodo_email_1 + ")!</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left no'>Ellenőrzöm az adatokat</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right yes'>Helyesek a megadott adatok</div></td></tr></table>";
                  engine.popMsg(msg);
              }
          }
          if ((szerzodo_email_1 == '' || typeof szerzodo_email_1 == 'undefined') && data.dealer_winliz_id > 10 && data.szerzodo_neme != 2) {
              if (data.szerzodo_winliz_id > 10 && data.szerzodo_u_emil != '' && data.dealer_winliz_id > 10 && data.kedv_340 == 0 && data.bizt != 2 && data.cbizt != 2 && data.ker_ert_csat != 4 && data.ker_ert_csat != 14) {
                  e.preventDefault();
                  var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>Biztos, hogy törli az e-mail címét?</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left nem'>Nem</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right torlom'>Igen, törlöm</div></td></tr></table>";
                  engine.popMsg(msg);
              }
          }
      });
      $('#pop_msg').on('click', '.ui-btn', function (e) {
         if ($(e.currentTarget).hasClass('no')) {
             engine.popMsg('');
         }
         else if ($(e.currentTarget).hasClass('torlom')) {
             row.cmd('delete_user_email', {winliz_id: data.szerzodo_winliz_id, email: data.szerzodo_u_emil, async: false});
             $(engine.settings.form.id).trigger('submit', 'confirmed');
         }
         else if ($(e.currentTarget).hasClass('yes')) {
             $(engine.settings.form.id).trigger('submit', 'confirmed');
         }
      });

   }
   
   szerzodo_email_check(data) {
      if (!data || typeof data == 'undefined') return;
      var msg = '';
      var row = $('#tb_szerzodo_email_1');
      if (typeof engine.row[row.data('id')] == 'undefined' || !row) {
          row = $('#tb_szerzodo_email_1_');
      }
 
      if((data.szerzodo_email_1 == '' || typeof data.szerzodo_email_1 == 'undefined') && (data.dealer_winliz_id == '' || typeof data.dealer_winliz_id == 'undefined' || data.bizt == 2 || data.cbizt == 2 || data.ker_ert_csat == 14 || (data.dealer_winliz_id != '' && typeof data.dealer_winliz_id != 'undefined' && (data.kedv_340 == 1 || data.kedv_340 == 2 || data.kedv_340 == 3 || (data.kedv_76 && data.bizt == 64))))) {
          msg += 'Kérjük, adja meg az e-mail címét!</br></br>';
      }
      
      if (typeof data.dealer_email != 'undefined' && data.dealer_email != '') {
          if(data.dealer_email == data.szerzodo_email_1 && data.dealer_adoszam != data.szerzodo_adoszam) {
              msg += 'A szerződő email címe nem egyezhet meg a partner email címével!</br></br>';
          }
      }
      if (data.szerzodo_email_1 == '' && data.szerzodo_neme == 2 && typeof data.dealer_email != 'undefined' && data.dealer_email != '') {
          msg += 'Szíveskedjen megadni a szerződő cég elektronikus elérhetőségét (e-mail cím), mivel a hatályos cégjog szerint a cég a cégnyilvántartásban bejelentette elektronikus elérhetőségét (e-mail címét). A cégnyilvántartásban szereplő aktuális e-mail cím megtekinthető a www.e-cegjegyzek.hu weboldalon, a díjmentesen letölthető cégkivonatban. Természetesen a Cég szerződőnek arra is lehetősége van, hogy a cégnyilvántartástól eltérő, de saját e-mail címét adja meg számunkra elektronikus értesítési címeként.</br></br>';
      }

      if (typeof data.szerzodo_winliz_id == 'undefined' || data.szerzodo_winliz_id == '') {
          row.cmd('get_user_email', {neme: data.szerzodo_neme, szul: data.szerzodo_szn, igszam: data.szerzodo_igszam, adoszam: data.szerzodo_adoszam, async: true}, function (row, o) {
              if (typeof o != 'undefined' && o.success) {
                  data.szerzodo_u_emil = o.email;
                  data.szerzodo_winliz_id = o.winliz_id;
              }
              
          });
      }

      if (data.dealer_winliz_id > 10 && data.szerzodo_winliz_id > 10 && data.szerzodo_u_emil != data.szerzodo_email_1) {
          console.log('five_email_check');
          if (data.szerzodo_neme == 2) {
              var ugyfel = $('#szerzodo_cegnev').val();
              if(data.szerzodo_adoszam == '' || data.szerzodo_adoszam == undefined) {
                  data.szerzodo_adoszam = $('#szerzodo_adoszam').val();
              }
          }
          else {
              var ugyfel = $('#szerzodo_vezeteknev').val() + ' ' + $('#szerzodo_keresztnev').val();
              if(data.szerzodo_igszam == '' || data.szerzodo_igszam == undefined) {
                  data.szerzodo_igszam = $('#szerzodo_igszam').val();
              }
          }
          row.cmd('five_email_check', {email: data.szerzodo_email_1, async: true}, function (row, o) {
              console.log('five_email_check ajax');
              if (typeof o != 'undefined' && o.success) {
                  if (o.db >= 5) {
                      msg += '</br></br>A megadott e-mail cím a rendszerünkben több mint 5 különböző ügyfélhez tartozik. Kérjük, szíveskedjék megadni az ügyfél valós e-mail címét.';
                  }
              }
          });

      }
      
      return msg;
   }

   szerzodo_kedv_email_check (e) {
       console.log('szerzodo_kedv_email_check');
//      if (c == 'confirmed') return;
//      var row = $('#tb_szerzodo_email_1');
//      if (typeof engine.row[row.data('id')] == 'undefined' || !row) {
//          row = $('#tb_szerzodo_email_1_');
//      }
//      var szerzodo_email = engine.row[row.data('id')].szerzodo_email;
//      var szerzodo_u_emil = engine.row[row.data('id')].szerzodo_u_emil;
//      var szerzodo_neme = engine.row[row.data('id')].szerzodo_neme;
//      var dealer_email = engine.row[row.data('id')].dealer_u_emil;
//      var dealer_adoszam = engine.row[row.data('id')].dealer_adoszam;
//      var szerzodo_adoszam = engine.row[row.data('id')].szerzodo_adoszam;
//      var dealer_winliz_id = engine.row[row.data('id')].dealer_winliz_id;
//      var szerzodo_winliz_id = engine.row[row.data('id')].szerzodo_winliz_id;
//      var szerzodo_szn = engine.row[row.data('id')].szerzodo_szn;
//      var szerzodo_igszam = engine.row[row.data('id')].szerzodo_igszam;
//      var kedv_340 = engine.row[row.data('id')].kedv_340;
//      var kedv_76 = engine.row[row.data('id')].kedv_76;
//      var bizt = engine.row[row.data('id')].gfb_bizt;
//      var cbizt = engine.row[row.data('id')].casco_bizt;
//
//      if (szerzodo_neme = undefined || szerzodo_neme == '') {
//          szerzodo_neme = $('#szerzodo_neme').val();
//      }
//console.log('szerzodo_email', szerzodo_email);
//      szerzodo_neme = szerzodo_neme * 1;
//      var szerzodo_email_1 = row.rVal();

//      if (typeof szerzodo_email != 'undefined' && szerzodo_email != '' && szerzodo_email) {
//          if((szerzodo_email_1 && szerzodo_email != szerzodo_email_1 && szerzodo_email != '' && szerzodo_email_1 != '')) {
              e.preventDefault();
              var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>A korábban megadott (kedvezményes oldalon) email cím nem egyezik a szerződő email címével!</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left no'>Ellenőrzöm az adatokat</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right yes'>Helyesek a megadott adatok</div></td></tr></table>";
              engine.popMsg(msg, 'pop_msg_email_kedv');
//          }
//      }
   }
   
   szerzodo_email_delete (e) {
//      $(engine.settings.form.id).on('click','.next', function (e, c) {
//          if (c == 'confirmed') return;
//          var row = $('#tb_szerzodo_email_1');
//          if (typeof engine.row[row.data('id')] == 'undefined' || !row) {
//              row = $('#tb_szerzodo_email_1_');
//          }
//          var szerzodo_email = engine.row[row.data('id')].szerzodo_email;
//          var szerzodo_u_emil = engine.row[row.data('id')].szerzodo_u_emil;
//          var szerzodo_neme = engine.row[row.data('id')].szerzodo_neme;
//          var dealer_email = engine.row[row.data('id')].dealer_u_emil;
//          var dealer_adoszam = engine.row[row.data('id')].dealer_adoszam;
//          var szerzodo_adoszam = engine.row[row.data('id')].szerzodo_adoszam;
//          var dealer_winliz_id = engine.row[row.data('id')].dealer_winliz_id;
//          var szerzodo_winliz_id = engine.row[row.data('id')].szerzodo_winliz_id;
//          var szerzodo_szn = engine.row[row.data('id')].szerzodo_szn;
//          var szerzodo_igszam = engine.row[row.data('id')].szerzodo_igszam;
//          var kedv_340 = engine.row[row.data('id')].kedv_340;
//          var kedv_76 = engine.row[row.data('id')].kedv_76;
//          var bizt = engine.row[row.data('id')].gfb_bizt;
//          var cbizt = engine.row[row.data('id')].casco_bizt;
//
//          if (szerzodo_neme = undefined || szerzodo_neme == '') {
//              szerzodo_neme = $('#szerzodo_neme').val();
//          }
//
//          szerzodo_neme = szerzodo_neme * 1;
//          var szerzodo_email_1 = row.rVal();
          
//          if ((szerzodo_email_1 == '' || typeof szerzodo_email_1 == 'undefined') && dealer_winliz_id > 10 && szerzodo_neme != 2) {
//              if (szerzodo_winliz_id > 10 && szerzodo_u_emil != '') {
                  e.preventDefault();
                  var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>Biztos, hogy törli az e-mail címét?</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left nemadom'>Nem</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right megadom'>Igen, törlöm</div></td></tr></table>";
                  engine.popMsg(msg, 'pop_msg_email_empty');
//              }
//              else {
//                  e.preventDefault();
//                  var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>Biztos, hogy nincs e-mail címe?</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left nemadom'>Nem, megadom</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right megadom'>Igen, biztos</div></td></tr></table>";
//                  engine.popMsg(msg, 'pop_msg_email_empty');
//              }
//          }
//       });
       
   }
   
   szerzodo_email_empty (e) {
//       e.preventDefault();
       var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>Biztos, hogy nincs e-mail címe?</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left nemadom'>Nem, megadom</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right megadom'>Igen, biztos</div></td></tr></table>";
       engine.popMsg(msg, 'pop_msg_email_empty');

       $('#pop_msg_email_empty').on('click', '.ui-btn', function (e) {
           if ($(e.currentTarget).hasClass('nemadom')) engine.popMsg('', 'pop_msg_email_empty');
//           else if ($(e.currentTarget).hasClass('megadom')) $(engine.settings.form.id).trigger('submit', 'confirmed_empty');
           else $(engine.settings.form.id).trigger('submit', 'confirmed_empty');
       });
   }

   no_paste (e) {
       var row = $(e.currentTarget);
       row.bind('copy paste',function(e) {
           e.preventDefault();
           return false;
       });
   }

   account_jump (e) {
       var row = $(e.currentTarget);
       var id = engine.rowmap[row.data('id')];
       var number = id.substring(id.length - 1);
       if (row.rVal().length == 8) {
           var num = parseInt(number) + 1;
           $('#szerzodo_szlasz_' + String(num)).focus();
       }
   }

   clb_javadalmazasa2(){
      $('a.clb_javadalmazasa2').on('click', function(e){
          var javadalmazas2 = engine.ajaxFunc('get_javadalmazas2');
          var text = '<div data-role="header" role="banner" class="ui-header ui-bar-inherit fizmodinfo">';
          text += '<div>Javadalmazás</div>';
          text += '<a href="#" data-rel="back" class="ui-btn-right ui-btn ui-btn-a ui-icon-delete ui-btn-icon-notext ui-shadow ui-corner-all" data-role="button" role="button">Bezár</a>';
          text += '</div>';
          text += '<div role="main" class="ui-content assistanceinfo">A CLB a megbízás alapján közvetített biztosítási szerződés (biztosítás) után a biztosítótól javadalmazásban részesül, közvetett díjazás keretében, ezért a biztosítás díja a biztosítótól származó - biztosítónként eltérő mértékű - közvetett díjazást tartalmaz, amely a közvetett díjazásból - biztosítónként eltérő mértékű - díjazásban részesül a CLB megbízottja, aki a közvetítésben közreműködik.<br/>A CLB által üzemeltetett weboldalon az Ügyfél által online megkötött utasbiztosítás esetében az Ügyfél által fizetendő díj az utasbiztosítás díján kívül '+javadalmazas2.value+' Ft közvetlen alkuszi díjazást is tartalmaz, amely közvetlen alkuszi díjazás megfizetésétől a CLB minden esetben eltekint (azt nem számolja bele a díjba), amennyiben az Ügyfél a saját CLB Ügyfélkapujából kezdeményezte és fejezte be az utasbiztosítás online megkötését. Ha a biztosító már kiállította a biztosítás kötvényét, akkor a '+javadalmazas2.value+' Ft közvetlen alkuszi díjazás megszolgáltnak tekinthető, így annak törlése vagy utólagos visszatérítése nem lehetséges. A CLB Ügyfélkapu elérhetősége: https://ugyfelkapu.clb.hu/</div>';
          engine.popMsg(text);
          e.stopPropagation();
      });
   }
   
   consent_cookie() {
      $('.agree-button').on('click', function(e){
          var exp = new Date();
          var year = exp.getFullYear() + 1;
          exp.setFullYear(year);
          document.cookie = "cookie-agreed=2; expires="+ exp.toUTCString() + "; path=/";
          document.cookie = "cookie-agreed-version=1.0.0; expires=" + exp.toUTCString() + "; path=/";
          $(".eu-cookie-compliance-banner").hide();
      });
   }
   
   pagechanger_make(e) {
        var row = $(e.currentTarget);
        var page = engine.row[row.data('id')].pagenum;
        var act_page = engine.ajaxFunc('get_session_val', {'id': 'page'}, false).value;
        var page_done = engine.ajaxFunc('get_session_val', {'id': 'page_done'}, false).value;
        console.log('pagechanger page: ' + page + ' page: ' + act_page + ' page_done: ' + page_done);
        $(engine.settings.form.id).on('click','.next', function (e, c){
            $('#tb_pagechanger_' + act_page).animate({
              height: 'toggle'
            }, 800);
        });
        if (page == act_page + 1) {
            $('#tb_pagechanger_' + act_page).animate({
              height: 'toggle'
            }, 800);
            $(engine.settings.form.id).trigger('submit');
        }
        else if (page < act_page) {
            engine.ajaxFunc('pageChanger', {'pagenum': page});
            $('#tb_pagechanger_' + act_page).animate({
              height: 'toggle'
            }, 800);
            $(engine.settings.form.id).trigger('submit');
//            location.reload();
        }
//        else if (page > act_page) {
//            if (page <= page_done + 1) {
//                $(engine.settings.form.id).trigger('submit');
//            }
//        }
   }
   
   pagechanger_onload(e) {
       var act_page = engine.ajaxFunc('get_session_val', {'id': 'page'}, false).value;
       console.log('akt page 1 ', act_page);
       $(document).ready(function (e, c){
           console.log('akt page 2 ', act_page);
           $('#tb_pagechanger_' + act_page).animate({
               height: 'toggle'
           }, 1);
           $('#tb_pagechanger_' + act_page).animate({
              height: 'toggle'
           }, 800);
       });
   }
   
   pagechenger_focus(e) {
       var act_page = engine.ajaxFunc('get_session_val', {'id': 'page'}, false).value;
       console.log('page focus ', act_page);
       $('#tb_pagechanger_' + act_page).scrollTop();
   }
   
   freemail_message(e) {
       var email = '';
       if ($('#tb_szerzodo_email').is(':visible')) {
           if (!email) email = $('#szerzodo_email').val();
       }
       if ($('#tb_szerzodo_email_').is(':visible')) {
           if (!email) email = $('#szerzodo_email_').val();
       }
       if ($('#tb_szerzodo_email_1').is(':visible')) {
           if (!email) email = $('#szerzodo_email_1').val();
       }
       if ($('#tb_szerzodo_email_1_').is(':visible')) {
           if (!email) email = $('#szerzodo_email_1_').val();
       }
       if (typeof email != 'undefined' && email.indexOf('freemail.hu') > -1) {
           $('#tb_freemail_msg').show();
       }
       else {
           $('#tb_freemail_msg').hide();
       }
   }
}

export default fn_core